import {
  HomeOutlined,
  HomeWorkOutlined,
  // SettingsOutlined,
  MapOutlined,
  ListAltOutlined,
  DriveEtaOutlined,
  AccountBoxOutlined,
  UploadFileOutlined,
  AssignmentOutlined,
  HistoryOutlined,
} from '@mui/icons-material';
import CreateWarehouse from '../pages/CreateWarehouse';
import HistoryOrders from '../pages/HistoryOrders';
import OrderDetails from '../pages/OrderDetails';
import UploadOrders from '../pages/UploadOrders';
import Notification from '../pages/Notification';
import OrderStatus from '../pages/OrderStatus';
import CreateUser from '../pages/CreateUser';
// import Settings from "../pages/Settings";
import Warehouse from '../pages/Warehouse';
import Vehicles from '../pages/Vehicles';
import Monitor from '../pages/Monitor';
import Orders from '../pages/Orders';
import Users from '../pages/Users';
import Home from '../pages/Home';
import USER_GROUPS, { ALL_GROUPS } from '../global/variables/userGroups';
import USER_ROLES from '../global/variables/userRoles';

const rolesA = [USER_ROLES.Administrador];
const rolesB = [USER_ROLES.Administrador, USER_ROLES.Leitor];

const groupsA = [USER_GROUPS.DHL];
const groupsB = [USER_GROUPS.DHL, USER_GROUPS.CPFL, USER_GROUPS.RGE, USER_GROUPS.CPFL_GERENCIAL];
const groupsC = ALL_GROUPS;
const managementGroups = [USER_GROUPS.DHL, USER_GROUPS.CPFL_GERENCIAL]

const routes = [
  {
    title: 'Início',
    icon: <HomeOutlined style={{ fontSize: 35, color: '#fff' }} />,
    path: '',
    import: <Home />,
    roles: rolesB, // ["Administrador", "Leitor"]
    groups: groupsA, // ["DHL"]
    navigation: true,
    private: true,
  },
  {
    title: 'Pedidos',
    icon: <ListAltOutlined style={{ fontSize: 35, color: '#fff' }} />,
    path: 'orders',
    import: <Orders />,
    roles: rolesB, // ["Administrador", "Leitor"]
    groups: groupsC, // ["DHL", "CPFL", "CPFL_DEPOSITO"]
    navigation: true,
    private: true,
  },
  {
    title: 'Pedido Detalhado',
    icon: <AssignmentOutlined style={{ fontSize: 35, color: '#fff' }} />,
    path: 'ordersdetails',
    import: <OrderDetails />,
    roles: rolesB, // ["Administrador", "Leitor"]
    groups: groupsC, // ['DHL', 'CPFL', 'CPFL_DEPOSITO']
    navigation: true,
    private: true,
  },
  {
    title: 'Mapa',
    icon: <MapOutlined style={{ fontSize: 35, color: '#fff' }} />,
    path: 'map',
    import: <Monitor />,
    roles: rolesB, // ["Administrador", "Leitor"]
    groups: groupsC, // ["DHL", "CPFL", "CPFL_DEPOSITO"]
    navigation: managementGroups, // ["DHL", "CPF_GERENCIAL"]
    private: true,
  },
  {
    title: 'Upload de Pedidos',
    icon: <UploadFileOutlined style={{ fontSize: 35, color: '#fff' }} />,
    path: 'uploadorders',
    import: <UploadOrders />,
    roles: rolesB, // ["Administrador", "Leitor"]
    groups: groupsA, // ["DHL"]
    navigation: true,
    private: true,
  },
  {
    title: 'Depósitos',
    icon: <HomeWorkOutlined style={{ fontSize: 35, color: '#fff' }} />,
    path: 'warehouse',
    import: <Warehouse />,
    roles: rolesB, // ["Administrador", "Leitor"]
    groups: groupsB, // ["DHL", "CPFL"]
    navigation: true,
    private: true,
  },
  {
    title: 'Depósitos',
    icon: <HomeWorkOutlined style={{ fontSize: 35, color: '#fff' }} />,
    path: 'createwarehouse',
    import: <CreateWarehouse />,
    roles: rolesA, // ["Administrador"]
    groups: groupsA, // ["DHL"]
    navigation: false,
    private: true,
  },
  {
    title: 'Depósitos',
    icon: <HomeWorkOutlined style={{ fontSize: 35, color: '#fff' }} />,
    path: 'editwarehouse/:id',
    import: <CreateWarehouse />,
    roles: rolesA, // ["Administrador"]
    groups: groupsA, // ["DHL"]
    navigation: false,
    private: true,
  },
  {
    title: 'Veículos',
    icon: <DriveEtaOutlined style={{ fontSize: 35, color: '#fff' }} />,
    path: 'vehicle',
    import: <Vehicles />,
    roles: rolesB, // ["Administrador", "Leitor"]
    groups: groupsA, // ["DHL"]
    navigation: true,
    private: true,
  },
  {
    title: 'Histórico de Pedido',
    icon: <HistoryOutlined style={{ fontSize: 35, color: '#fff' }} />,
    path: 'historyorders',
    import: <HistoryOrders />,
    roles: rolesB, // ["Administrador", "Leitor"]
    groups: groupsA, // ["DHL"]
    navigation: true,
    private: true,
  },
  {
    title: 'Usuários',
    icon: <AccountBoxOutlined style={{ fontSize: 35, color: '#fff' }} />,
    path: 'users',
    import: <Users />,
    roles: rolesB, // ["Administrador", "Leitor"]
    groups: groupsA, // ["DHL"]
    navigation: true,
    private: true,
  },
  {
    title: 'Usuários',
    icon: <AccountBoxOutlined style={{ fontSize: 35, color: '#fff' }} />,
    path: 'createuser',
    import: <CreateUser />,
    roles: rolesA, // ["Administrador"]
    groups: groupsA, // ["DHL"]
    navigation: false,
    private: true,
  },
  {
    title: 'Usuários',
    icon: <AccountBoxOutlined style={{ fontSize: 35, color: '#fff' }} />,
    path: 'edituser/:id',
    import: <CreateUser />,
    roles: rolesA, // ["Administrador"]
    groups: groupsA, // ["DHL"]
    navigation: false,
    private: true,
  },

  // {
  //   title: "Configurações",
  //   icon: <SettingsOutlined style={{ fontSize: 35, color: "#fff" }} />,
  //   path: "settings",
  //   import: <Settings />,
  //   roles: rolesB, // ["Administrador", "Leitor"]
  //   groups: groupsC, // ["DHL", "CPFL", "CPFL_DEPOSITO"]
  //   navigation: true,
  //   private: true,
  // },
  {
    path: 'notification/:id',
    import: <Notification />,
    roles: rolesB, // ["Administrador", "Leitor"]
    groups: groupsC, // ["DHL", "CPFL", "CPFL_DEPOSITO"]
    navigation: false,
    private: true,
  },
  {
    path: 'orderstatus',
    import: <OrderStatus />,
    roles: rolesB, // ["Administrador", "Leitor"]
    groups: groupsC, // ["DHL", "CPFL", "CPFL_DEPOSITO"]
    navigation: false,
    private: true,
  },
];

export default routes;
